import { render, staticRenderFns } from "./AddEditDepartment.vue?vue&type=template&id=7cf55052"
import script from "./AddEditDepartment.vue?vue&type=script&lang=js"
export * from "./AddEditDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports